export default {
  BUBudgetItemCollect: {
    Title: 'Mục/ Tiểu mục thu',
    Category: 'Danh mục',
    Link: '/ Mục lục ngân sách / Mục, Tiểu mục thu',
    All: 'Tất cả',
    Search: 'Tìm kiếm theo Mã, Tên mục/ tiểu mục...',
    Following: 'Theo dõi',
    UnFollowing: 'Ngừng theo dõi',
    Add: 'Thêm',
    Type: 'Loại',
    GroupCode: 'Mã nhóm *',
    Group: 'Thuộc nhóm *',
    SubGroup: 'Thuộc tiểu nhóm',
    Item: 'Thuộc mục *',
    GroupName: 'Tên nhóm *',
    SubGroupCode: 'Mã tiểu nhóm *',
    SubGroupName: 'Tên tiểu nhóm *',
    ItemCode: 'Mã mục *',
    ItemName: 'Tên mục *',
    SubItemCode: 'Mã tiểu mục *',
    SubItemName: 'Tên tiểu mục *',
    CollectList: 'Nhóm mục chi',
  },
  BUBudgetItemCollectDetail: {},
  BUBudgetItemSpend: {
    Title: 'Mục/ Tiểu mục chi',
    Link: '/ Mục lục ngân sách / Mục/ Tiểu mục chi',
    SpendList: 'Nhóm mục chi',
  },
  BUBudgetItemSpendDetail: {},
};
